import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';

const query = gql`
  query {
    indicatorStages {
      dbId
      name
    }
  }
`;

export const useIndicatorStage = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'cache-first' });
  const data = (rawData?.indicatorStages || []).map(row => ({ ...row, id: row.dbId }));
  return { data, refetch, loading };
};
